'use client';

import { observer } from 'mobx-react';
import { FREETEXT_KEYS } from '~/const/freetext';
import { getStore } from '~/mobx/AppStore';
import SafeHTML from '../SafeHTML/SafeHTML';

interface Props {
    isLoggedIn: boolean;
    noElectionActiveError?: boolean;
    freetextContent: string;
    freetextCopyright: string;
}

const Footer = (props: Readonly<Props>) => {
    const { isLoggedIn, noElectionActiveError, freetextContent, freetextCopyright } = props;

    if (isLoggedIn && !noElectionActiveError) return null;

    return (
        <footer className="fixed bottom-0 mt-12 w-full bg-[#003050] py-4 lg:py-7">
            <div className="container-fluid">
                <SafeHTML className="mb-3 text-white lg:mb-4" html={freetextContent} />
                <SafeHTML className="mb-[10px] text-white" html={freetextCopyright} />
            </div>
        </footer>
    );
};

const FooterWithStore = observer(() => {
    const { ballotStore, previewStore, freetextStore } = getStore();
    const isLoggedIn = ballotStore.getIsLoggedIn();
    const isPreview = previewStore.isInitialized;
    const noElectionActiveError = ballotStore.getNoActiveElectionError();
    const freetextContent = freetextStore.getFreetextValueByKey(FREETEXT_KEYS.footer_content);
    const freetextCopyright = freetextStore.getFreetextValueByKey(FREETEXT_KEYS.footer_copyright);

    return (
        <Footer
            isLoggedIn={isLoggedIn || isPreview}
            noElectionActiveError={noElectionActiveError.isError}
            freetextContent={freetextContent}
            freetextCopyright={freetextCopyright}
        />
    );
});

export default FooterWithStore;
